import { r as registerInstance, h } from './index-16dc7dde.js';
import { t as tryParse } from './parsers-e38ff6a5.js';
import './utils-15ad90ec.js';
import './lookups-705fb53e.js';
import './request.constants-deb285e0.js';
import './isObject-33fa1780.js';
import './send-33ade633.js';
import './analytics-765d4daf.js';
import './utils-913bdf8a.js';
import './tslib.es6-2af8cb53.js';
import './_commonjsHelpers-ba3f0406.js';
import './_isIndex-af307327.js';
import './toNumber-5000b45d.js';
import './isSymbol-45bfef0c.js';
import './currency-b61904e0.js';

const recentlyViewedContainerCss = ":host{display:block}@media screen and (max-width: 979px){:host{margin-bottom:44px}}@media screen and (min-width: 980px){:host(.subcategory) .recently-viewed-container{margin-bottom:72px}}@media screen and (max-width: 979px){:host(.subcategory) .recently-viewed-container{margin-bottom:48px}}";

let RecentlyViewedContainer = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
  }
  componentWillLoad() {
    var _a;
    this.url = (_a = tryParse(this._url)) !== null && _a !== void 0 ? _a : this.url;
    this.fetchData();
  }
  fetchData() {
    if (!this.url || window.isAsco)
      return;
    const urlParamSymbol = this.url.includes('?') ? '&' : '/?';
    fetch(`${this.url}${urlParamSymbol}ts=${Date.now()}`, {
      credentials: 'include',
    })
      .then((response) => {
      return response.json();
    })
      .then((data) => {
      this.result = data;
    })
      .catch(() => {
    });
  }
  render() {
    if (this.result && this.result.data.length) {
      return h("pes-products-carousel", Object.assign({ class: "recently-viewed-container" }, this.result));
    }
  }
  static get watchers() { return {
    "url": ["fetchData"]
  }; }
};
RecentlyViewedContainer.style = recentlyViewedContainerCss;

export { RecentlyViewedContainer as pes_recently_viewed_container };
